export const changePriceToNumber = (price) => {
  if (typeof price === 'string') {
    return parseInt(price.replace(/,|\$/g, ''));
  } else {
    return price;
  }
};
